export enum ERealEstateBoard {
    rebgv = 'rebgv',
    crea = 'crea',
    treb = 'treb',
}

export class RealEstatePoliceService {
    public readonly claimAlpha = {
        realEstateBoards: [ERealEstateBoard.crea, ERealEstateBoard.treb],
        content: `The listing data above is provided under copyright by the Toronto Real Estate Board. Information is deemed reliable
        but is not guaranteed accurate.
        MLS®, REALTOR® & associated logos are trademarks of The Canadian Real Estate Association.`,
    };
    public readonly claimBeta = {
        realEstateBoards: [ERealEstateBoard.rebgv],
        content: `<div style="font-weight: bold;">Copyright 2016 Chilliwack
        & District Real Estate Board, Fraser Valley Real Estate Board
        and Real Estate Board of Greater Vancouver. All rights reserved.</div><br />
        <div>NOTE: This representation is
        based in whole or in part on data generated by Chilliwack &
        District Real Estate Board, Fraser Valley Real Estate Board or
        Real Estate Board of Greater Vancouver, which assume(s) no responsibility for its accuracy.
        This website must only be used by consumers for the purpose of locating and purchasing
        real estate. In Canada, the trademarks MLS®, Multiple Listing Service® and the associated
        logos are owned by The Canadian Real Estate Association (CREA) and identify the quality of services provided by real estate professionals who are members of CREA.</div>`,
    };
    constructor() { }
}
